import { useAuth } from '@/features/auth/hooks/useAuth'
import { RoleType, type User } from '@promo/shared'
import { Navigate } from 'react-router-dom'
import { InsightsDashboard } from '@/features/insights/components/InsightsDashboard'
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export default function InsightsPage() {
  const { session } = useAuth()
  const user = session.user

  // Fetch users by role (same as Navbar)
  const managersQuery = useQuery<User[], Error>({
    queryKey: ['users', 'by-role', RoleType.MANAGER],
    queryFn: () => get<User[]>('/users', { role: RoleType.MANAGER }),
  })
  const seniorLeadersQuery = useQuery<User[], Error>({
    queryKey: ['users', 'by-role', RoleType.SENIOR_LEADER],
    queryFn: () => get<User[]>('/users', { role: RoleType.SENIOR_LEADER }),
  })
  const hrMembersQuery = useQuery<User[], Error>({
    queryKey: ['users', 'by-role', RoleType.HR],
    queryFn: () => get<User[]>('/users', { role: RoleType.HR }),
  })
  const barRaisersQuery = useQuery<User[], Error>({
    queryKey: ['users', 'by-role', RoleType.BAR_RAISER],
    queryFn: () => get<User[]>('/users', { role: RoleType.BAR_RAISER }),
  })

  const managers = managersQuery.data ?? []
  const seniorLeaders = seniorLeadersQuery.data ?? []
  const hrMembers = hrMembersQuery.data ?? []
  const barRaisers = barRaisersQuery.data ?? []
  const loadingRoles = managersQuery.isLoading || seniorLeadersQuery.isLoading || hrMembersQuery.isLoading || barRaisersQuery.isLoading

  if (!user || loadingRoles) {
    // Optionally show a loading spinner here
    return null
  }

  const userId = user.id
  const hasAccess = [...managers, ...seniorLeaders, ...hrMembers, ...barRaisers].some(u => u.id === userId)

  if (!hasAccess) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="container mx-auto py-6">
      <InsightsDashboard />
    </div>
  )
} 